<nav class="cp-tabs">
  <a routerLink="/composite-products" routerLinkActive="active" [routerLinkActiveOptions]="cardsLink">{{ 'compositeProducts.tabs.cards' | transloco }}</a>
  <a routerLink="/composite-products/sections" routerLinkActive="active">{{ 'compositeProducts.tabs.sections' | transloco }}</a>
  <a routerLink="/composite-products/labels" routerLinkActive="active">{{ 'compositeProducts.tabs.labels' | transloco }}</a>
  <a routerLink="/composite-products/uncovered" routerLinkActive="active">
    {{ 'compositeProducts.tabs.uncovered' | transloco }}
    @if (badge.uncovered$ | async; as count) {
      <nz-badge class="cp-tabs__count" [nzCount]="count" [nzOverflowCount]="999"></nz-badge>
    }
  </a>
</nav>
